module.exports = __WEBPACK_EXTERNAL_MODULE_84__;


//////////////////
// WEBPACK FOOTER
// external "fenix-ui-table-creator"
// module id = 84
// module chunks = 0